import type { Page } from '@branditdev/mf-types'
import React, { useEffect, useMemo } from 'react'
import { fetchPortalPage } from '../../redux/storeConfig/slices/slice.portalPages'
import { isRenderablePageContentBlock } from '../../redux/storeConfig/slices/slice.portalPages/portalPages.types'
import { useAppDispatch, useAppSelector } from '../../redux/storeConfig/store'
import ContentLoader from '../global/loaders/ContentLoader'
import BannerSliderThree from '../widgets/BannerSliderThree'
import FeaturesV2 from '../widgets/FeaturesV2'
import LinkColumn from '../widgets/LinkColumn'
import FaqBlock from './FaqBlock'
import GenericBlock from './GenericBlock'

type PortalPageProps = {
  page: Page
}

const PortalPage = ({ page }: PortalPageProps) => {
  const dispatch = useAppDispatch()
  const fetchedPage = useAppSelector(state => state.portalPages.data[page.id]?.page)

  useEffect(() => {
    if (page.id) {
      dispatch(fetchPortalPage(page.id))
    }
  }, [dispatch, page.id])

  const sortedBlocks = useMemo(
    () =>
      (fetchedPage?.page_content_blocks ?? [])
        .filter(isRenderablePageContentBlock)
        .sort((a, b) => (a.order ?? 0) - (b.order ?? 0)),
    [fetchedPage]
  )

  if (!page.id || !fetchedPage) return <ContentLoader />

  return (
    <div>
      {sortedBlocks.map((block, i) => {
        switch (block.content_type) {
          case 'Slider':
            return (
              <div className="iron-home-v2-wrap" key={i}>
                <div className="iron-banner-wrapper py-30">
                  <div className="mf-container">
                    <BannerSliderThree blockContent={block.child_content} />
                  </div>
                </div>
              </div>
            )

          case 'LinkColumn':
            return (
              <div className="iron-home-v2-wrap" key={i}>
                <div className="iron-cta-wrapper py-30">
                  <div className="mf-container">
                    <LinkColumn linkColItems={block.child_content.items} />
                  </div>
                </div>
              </div>
            )

          case 'Feature':
            return (
              <div className="iron-home-v2-wrap" key={i}>
                <div className="iron-feature-wrapper py-30">
                  <div className="mf-container">
                    <FeaturesV2 siteFeatures={block.child_content.items} />
                  </div>
                </div>
              </div>
            )

          case 'Generic':
            return (
              <div className="iron-home-v2-wrap py-30" key={i}>
                <GenericBlock content={block} />
              </div>
            )

          case 'FAQ':
            return (
              <div className="iron-home-v2-wrap py-30" key={i}>
                <div className="container">
                  <FaqBlock content={block} />
                </div>
              </div>
            )

          default:
            return null
        }
      })}
    </div>
  )
}

export default PortalPage
